import classNames from 'classnames';
import { forwardRef } from 'react';
const removalOptionWrapperCss = "r109fhln";
export const RemovalOptionWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(removalOptionWrapperCss, props.className)} />;
});
const wrapperCss = "w1vdqdxo";
export const Wrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(wrapperCss, props.className)} />;
});
const removalOptionDisabledCss = "rpstdtj";
const removalOptionCss = "rre5qu6";
export const RemovalOption = forwardRef((props, ref) => {
  const {
    disabled,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(removalOptionCss, {
    [removalOptionDisabledCss]: disabled
  }, props.className)} />;
});
const labelCss = "l129jo7p";
export const Label = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'label';
  return <Component ref={ref} {...restProps} className={classNames(labelCss, props.className)} />;
});
const labelTextCss = "lj3ke37";
export const LabelText = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(labelTextCss, props.className)} />;
});
const descriptionCss = "d1n4t5a9";
export const Description = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'p';
  return <Component ref={ref} {...restProps} className={classNames(descriptionCss, props.className)} />;
});
const warningCss = "w19deve1";
export const Warning = forwardRef((props, ref) => <Description ref={ref} {...props} className={classNames(warningCss, props.className)} />);

require("./shared.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./shared.js");